import React, {useState} from 'react';
import {Card, Flex, List} from "antd";
import UserInformation from "../../components/userInformation/UserInformation";
import {CategoryListCard} from "../../../product/components";
import ProfileListCard from "../../components/profileListCard/ProfileListCard";
import {StyledCard} from "./Profile.styled";
import LogOutModal from "../../components/profileListCard/LogOutModal";

const Profile = () => {
    const [open, setOpen] = useState<boolean>(false);


    const onCansel = () => {
        setOpen(false);
    }

    const data = [
        {
            title: 'آگهی های مورد علاقه',
            path: '/bookmark-list',
        },
        {
            title: 'آگهی های من',
            path: '/user-products',
        },
        {
            title: 'درباره ما',
        },
        {
            title: 'پنل مدیریت',
            path: '/admin-panel',
        },
        {
            title: 'خروج از حساب کاربری',
        },
    ]
    return (
        <Flex justify={"center"} gap={"large"} vertical>
            <UserInformation/>
            <StyledCard>
                <List
                    size="large"
                    dataSource={data}
                    renderItem={(item) => <List.Item><ProfileListCard item={item}
                                                                      clickedOnLogOut={() => setOpen(true)}/></List.Item>
                }
                />
            </StyledCard>
            {open && <LogOutModal open={open} onCansel={onCansel}/>}

        </Flex>
    );
};

export default Profile;